import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { apiClient } from '../../lib/util';
import { PersonioSync, PersonioSyncDetail, Personio } from '@pxtra-client-lib-legacy/gen';

export function listPersonioSyncLogsQuery(companyId: string) {
  return useQuery<PersonioSync[]>({
    queryKey: ['company', companyId, 'personio', 'sync'],
    queryFn: async () => {
      const logs = await apiClient.integrations.companiesPersonioSyncList({
        parentCompany: companyId ?? 'MISSING_COMP_ID'
      });

      return logs.results;
    }
  });
}

export function retrievePersonioSyncLogQuery(companyId: string, logId: string) {
  return useQuery<PersonioSyncDetail>({
    queryKey: ['company', companyId, 'personio', 'sync', logId],
    queryFn: async () => {
      const log = await apiClient.integrations.companiesPersonioSyncRetrieve({
        parentCompany: companyId ?? 'MISSING_COMP_ID',
        id: logId
      });

      return log;
    }
  });
}

export function getPersonioDetailsQuery(
  companyId: string,
  options?: Omit<UseQueryOptions<Personio[]>, 'queryKey' | 'queryFn'>
) {
  return useQuery<Personio[]>({
    queryKey: ['company', companyId, 'personio'],
    queryFn: async () => {
      const details = await apiClient.integrations.companiesPersonioList({
        parentCompany: companyId ?? 'MISSING_COMP_ID'
      });

      return details.results;
    },
    ...options
  });
}

export function triggerPersonioPayrollSyncMutation(
  options?: Omit<
    UseMutationOptions<
      import('@pxtra-client-lib-legacy/gen').PayrollSyncStatus,
      Error,
      { companyId: string; accountingPeriod: string }
    >,
    'mutationFn'
  >
) {
  return useMutation<
    import('@pxtra-client-lib-legacy/gen').PayrollSyncStatus,
    Error,
    { companyId: string; accountingPeriod: string }
  >({
    mutationFn: async ({ companyId, accountingPeriod }) =>
      apiClient.integrations.companiesPersonioSyncTriggerCreate({
        parentCompany: companyId ?? 'MISSING_COMP_ID',
        requestBody: {
          accounting_period: accountingPeriod
        }
      }),
    ...options
  });
}
